// api.js
import axios from 'axios';
import { ElMessage } from 'element-plus';
import refreshToken from "@/api/refreshToken";
import {apiLoadingClose, apiLoadingStart} from "@/api/apiLoading";


const BASE_URL = process.env.VUE_APP_API_BASE_URL;
// 创建axios实例
const apiClient = axios.create({
    baseURL: BASE_URL, // 替换为你的API服务地址
    timeout: 15000, // 设置超时时间（可选）
    headers: {
        'Content-Type': 'application/json', // 设置请求头（可选）
    },
});

// 统一的错误处理函数
function handleRequestError(error) {
    // 在这里处理错误，例如统一弹出错误提示、记录错误日志等
    // console.error('请求错误:', error);
    ElMessage({
        message: "服务繁忙,请稍等."+error.message,
        type: 'warning',
    })
}



function requestLodingBusOn(){
    // nprogressStart();
    apiLoadingStart();
}

function requestLodingBusOff(){
    //nprogressClose();
    apiLoadingClose();
}


//请求拦截器
apiClient.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // 显示请求进度条
    requestLodingBusOn();
    // 添加token
    var Authtoken = (localStorage.getItem("loginUserStore") == null) ? "" : JSON.parse(localStorage.getItem("loginUserStore")).auth_token
    config.headers.Authtoken = Authtoken;
    return config;


}, handleRequestError);

//响应拦截器
apiClient.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
},handleRequestError);


// 统一的接口调用函数
async function callApi(url, method, data = null) {
    try {
        const response = await apiClient.request({
            url,
            method,
            data,
        });

        // 特殊的状态码处理
        // -2 未登录或authToken过期
        if(response.data.code ==  -2){
            // 刷新token
            var retMsg = await refreshToken()
            // refreshtoken都失效了则到首页
            if(retMsg !== "success"){
                if(window.parent.location.pathname === "/index"){
                    window.parent.location.href="/"
                }else{
                    window.parent.location.href="/?redirect="+window.location.pathname
                }

            }
            return;
        }
        // 刷新token失效,去登录页面
        if(response.data.code ==  -4){
            localStorage.removeItem("loginUserStore");
            if(window.parent.location.pathname === "/index" ||  window.parent.location.pathname === "/"){
                window.parent.location.href="/"
            }else{
                window.parent.location.href="/?redirect="+window.location.pathname
            }
            return;
        }
        if(response.data.code !== 200){
            ElMessage({
                message: response.data.msg,
                type: 'warning',
            })
            return ;
        }
        return response.data;
    } catch (error) {
        handleRequestError(error);
    } finally {
        // 关闭请求动画
        requestLodingBusOff();
    }
}
// 导出接口调用函数
export default callApi;

// 排查登录页面 必须写在callApi下面
const publicPaths = ['/phone/batteryDpiView', '/pb', '/phone/batteryP2View', '/p2', '/thirdLogin']
if (window.location.pathname !== '/' && !publicPaths.some(p => window.location.pathname.startsWith(p))) {
    await callApi('/infoaccountadmin/userLogin/checkLogin', 'post')
}